const state = {
    /** 
     * Массив с данными, передаваемый в модальное окно для отображения 
    */
    modalNotificationMessage: []
};

const getters = {
    modalNotificationMessage: state => {
      return state.modalNotificationMessage
    }
};

const mutations = {
    modalNotificationMessage: (state, payload) => {
      return state.modalNotificationMessage = payload
    }
};

const actions = {
  modalNotificationMessageClose({commit}) {
    commit('modalNotificationMessage', [])
  },
  modalNotificationMessageOpen({commit, dispatch}, data) {
    commit('modalNotificationMessage', data)
    setTimeout(() => {
      dispatch('modalNotificationMessageClose')
    }, 5000)
  }
};

export default {
    state,
    getters,
    mutations,
    actions
}